import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type { onBoardPayload, OnBoardService } from "../utils/types/onBoard";

export const fetchOnBoard = async (berthId?: string, jobId?: string) => {
  const params: { [key: string]: any } = {};
  if (berthId) {
    params.bearthId = berthId; // Fixed: was "bearthId" (typo)
    params.jobId = jobId;
  }

  if (jobId) {
    params.jobId = jobId;
  }
  const response = await axiosServices.get("/onboardservices", {
    params,
  });
  return convertToCamelCase<OnBoardService[]>(response.data.data);
};

export const updateOnBoard = async (
  id: string,
  berthId?: string,
  jobId?: string,
  data?: {
    [key: string]: any;
    onBoardServiceId: string;
  }
) => {
  const params: { [key: string]: any } = {};
  if (data && jobId) {
    data.job_id = jobId; // Fixed: was "job_id" (typo)
  }
  if (berthId) {
    params.berthId = berthId; // Fixed: was "bearthId" (typo)
  }
  const payloadData = convertToSnakeCase(data);
  await axiosServices.put(`/onboardservices/${id}`, payloadData, {
    params,
  });
  return data;
};

export const deleteOnBoard = async (data: { id: string; berthId: string }) => {
  const response = await axiosServices.delete(`/onboardservices/${data.id}`, {
    params: {
      bearthId: data.berthId,
    },
  });
  return response.data;
};

export const addOnBoard = async (data: onBoardPayload) => {
  const payloadData = convertToSnakeCase(data);
  const response = await axiosServices.post("/onboardservices", payloadData, {
    params: {
      bearthId: data.berthId,
    },
  });
  return convertToCamelCase<OnBoardService>(response.data.data);
};

export const moveOnBoard = async (id: string, berthId: string) => {
  await axiosServices.put(`/onboardservices/${id}`, {
    berth_id: berthId,
  });
};
